"use client";

import {Form} from "@/components/ui/form";
import {useForm} from "react-hook-form";
import {CWFInput} from "@/components/ui/CWFInput";
import * as yup from "yup";
import {yupResolver} from "@hookform/resolvers/yup";
import {useState} from "react";
import {signIn} from "next-auth/react";
import CWFButton from "@/components/ui/CWFButton";
import ForgotPassRequest from "@/components/site/forgot/ForgotPassRequest";
import ForgotPassAction from "@/components/site/forgot/ForgotPassAction";

const REQUIRED_ERROR = "Ce champ est requis."

const formSchema = yup.object({
    email: yup.string().email("Veuillez fournir une adresse email valide.").required(REQUIRED_ERROR),
    password: yup.string().required(REQUIRED_ERROR),
});




export default function LoginForm({ onSuccess }) {

    const form = useForm({
        resolver: yupResolver(formSchema)
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [showPass, setShowPass] = useState(false);
    const [forgotPass, setForgotPass] = useState(false);
    const [forgotAction, setForgotAction] = useState(false);
    function onSubmit(data) {
        setError(false);
        setLoading(true);
        signIn("cwf", { ...data, redirect: false})
            .then(res => {
                if (!res?.ok) {
                    setError(true);
                    return;
                }
                onSuccess?.();
            })
            .catch(() => setError(true))
            .finally(() => setLoading(false))
    }



    if(forgotPass){
        return(
            <>
                {!forgotAction ?
                    <>
                        <ForgotPassRequest setForgotPass={setForgotPass} setActionPass={setForgotAction}/>
                    </>
                    :
                        <ForgotPassAction setForgotPass={setForgotPass}/>

                }
            </>

        )
    }else{
        return (
            <Form {...form}>
                <form onSubmit={form.handleSubmit(onSubmit)} className="grid gap-4">
                    {error && (
                        <p className="rounded-md border border-red-300 bg-red-50 text-red-500 text-center text-sm p-1">
                            Adresse email et/ou mot de passe invalide.
                        </p>
                    )}
                    <CWFInput control={form.control} name="email" label="Adresse email" type="email" />
                    <CWFInput control={form.control} name="password" label="Mot de passe" type={showPass ? "text" : "password"} withIcon={true} setShowPass={setShowPass} showPass={showPass} />
                    <div className={"flex justify-end"}>
                        <p className={"text-sm text-primary underline cursor-pointer"} onClick={() => setForgotPass(true)}>Mot de passe oublié</p>
                    </div>
                    <CWFButton type="submit" loading={loading}>Connexion</CWFButton>
                </form>
            </Form>
        );
    }

}
